/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment } from "react";
import DisplayTextOnly from "cms/fields/layout/controls/display-text-only";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";

const HeadingFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { values } = field || {};

    return (
        <FieldDisplayWrapper>
            {values &&
                values.map((item, index) => {
                    const { value, settings } = item || {};
                    const { style } = settings || {};
                    return (
                        <Fragment key={index}>
                            <DisplayTextOnly
                                value={value}
                                style={style}
                            />
                        </Fragment>
                    );
                })}
        </FieldDisplayWrapper>
    );
};
HeadingFieldDisplay.displayName = "HeadingFieldDisplay";
export { HeadingFieldDisplay };
